import styles from './SendRemainder.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';

import { RiMailSendFill } from 'react-icons/ri';

const SendRemainder = () => {
  const dispatch = useDispatch();
  const handleSave = () => {
    console.log('remainder sent:');
    dispatch(closeModal());
  };

  const handleClose = () => {
    dispatch(closeModal());
    console.log('remainder not sent');
  };

  const handleCancel = () => {
    dispatch(closeModal());
    console.log('remainder not sent');
  };

  return (
    <div className={styles.cardContainer}>
      {/* Header */}
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<RiMailSendFill />}
          heading="Send Remainder"
          color="var(--Primary_Color)"
        />
        <ToClose onClose={handleClose} />
      </div>

      {/* Body */}
      <div className={styles.body}>
        <p className={styles.title}>Send reminder email to parent ?</p>
        <p className={styles.subText}>Click yes to send</p>

        <div className={styles.actions}>
          <SaveAndCancel
            onSave={handleSave}
            onCancel={handleCancel}
            saveLabel="No"
            cancelLabel="Yes"
          />
        </div>
      </div>
    </div>
  );
};

export default SendRemainder;
